"use strict";
exports.__esModule = true;
exports.CONFIRM_ACCOUNT = exports.CREATE_ACCOUNT = void 0;
exports.CREATE_ACCOUNT = {
    HEADER: 'Create your account',
    SUBHEADER: 'We need a few basic pieces of information to get started.',
    FIRST_NAME_LABEL: 'First name (legal)',
    LAST_NAME_LABEL: 'Last name (legal)',
    CTA: 'Create account',
    DISCLOSURES_LINE_1: 'By creating an account, you agree to Flex’s '
};
exports.CONFIRM_ACCOUNT = {
    HEADER: 'Confirm your information',
    SUBHEADER: 'This should match what your property has on file.',
    FIRST_NAME_LABEL: 'First name (legal)',
    LAST_NAME_LABEL: 'Last name (legal)',
    CTA: 'Confirm'
};
